var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-tip-container" },
    [
      _vm.showTooltip
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.slotText,
                placement: _vm.placement,
                effect: _vm.effect,
                disabled: !_vm.showTooltip,
              },
            },
            [
              _c(
                "span",
                {
                  class: [
                    "text-content",
                    { "text-ellipsis": _vm.type === "auto" },
                  ],
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.copyText },
                },
                [_vm._v(" " + _vm._s(_vm.truncatedText) + " ")]
              ),
            ]
          )
        : _c(
            "span",
            {
              class: ["text-content", { "text-ellipsis": _vm.type === "auto" }],
              staticStyle: { cursor: "pointer" },
              on: { click: _vm.copyText },
            },
            [_vm._t("default")],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }